export default {
	install (Vue) {
		Vue.prototype.$errorsMod = function (methodOptions) {
			
			if (process.env.NODE_ENV === 'development') {
				try {
					console.log('error development', methodOptions)
					//console.log('error development array', Array.isArray(methodOptions.data))
				} catch(e) {
					console.log(e)
				}

			}
			
			if (methodOptions === undefined) {
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Произошла ошибка. Сервер не отвечает',
                    text: `Обратитесь в техподдержку`,
                    position: 'right',
                    speed: 1000
                })
				return true //возвращаем ошибку так как описание отсутствует, скорее всего это ошибка соединения
			} else {
				if (methodOptions.status === 400) {
					try {
						for(let error in methodOptions.data) {
							console.log(error)
							this.$notify({
								group: 'foo',
								type: 'error',
								title: 'Произошла ошибка',
								text: methodOptions.data[error][0],
								position: 'right',
								speed: 1000
							});
						}
					} catch(e) {
						this.$notify({
							group: 'foo',
							type: 'error',
							title: 'Произошла ошибка',
							text: `Что-то пошло не так, обратитесь в техподдержку`,
							position: 'right',
							speed: 1000
						})	
					}
				} else {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Произошла ошибка',
                        text: `Что-то пошло не так, обратитесь в техподдержку`,
                        position: 'right',
                        speed: 1000
                    })
				}
				return false
			}
		}
	}
}


